import { error, FlowStepFragment } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const currentFlowStep = gql`
  query currentFlowStep {
    currentFlowStep(input: { flowName: INTENT_BASED_ONBOARDING }) {
      __typename
      ...FlowStepFragment
      ... on NoStepFound {
        id
        __typename
      }
      ... on FlowStepError {
        ...error
        __typename
      }
    }
  }
  ${FlowStepFragment}
  ${error}
`;

export default currentFlowStep;
